import * as types from './types';

export default {

  [types.SET_SESSION](state, value) {
    state.session = value;
  },
  [types.SET_PROFILE](state, value) {
    state.profile = value;
  },
  [types.SET_USER_INFOS](state, value) {
    state.user = value;
  },
  [types.SET_USAGE_DATAS](state, value) {
    state.usageDatas = value;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js